import React from 'react';

import ProviderStatement from '@/b2b/pages/PolicyStatement/Header/ProviderStatement';
import SelectCurrency from '@/b2b/pages/PolicyStatement/Header/SelectCurrency';
import SelectMonth from '@/b2b/pages/PolicyStatement/Header/SelectMonth';
import SelectPolicy from '@/b2b/pages/PolicyStatement/Header/SelectPolicy';

const Header = () => (
  <>
    <SelectPolicy />
    <SelectCurrency />
    <SelectMonth />
    <ProviderStatement />
  </>
);
export default Header;
